module.exports = __webpack_public_path__ + "static/leaves@2x-6c87e01a0c782106c83178fdd7c5e906.png";